module.exports = __webpack_public_path__ + "img/logo-company.7b2247aa.png";